/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputEwFrequencyRangeInput
 */
export interface InputEwFrequencyRangeInput {
    /**
     * 
     * @type {number}
     * @memberof InputEwFrequencyRangeInput
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof InputEwFrequencyRangeInput
     */
    min: number;
    /**
     * 
     * @type {string}
     * @memberof InputEwFrequencyRangeInput
     */
    unit: InputEwFrequencyRangeInputUnitEnum;
}


/**
 * @export
 */
export const InputEwFrequencyRangeInputUnitEnum = {
    Mhz: 'MHz',
    Ghz: 'GHz'
} as const;
export type InputEwFrequencyRangeInputUnitEnum = typeof InputEwFrequencyRangeInputUnitEnum[keyof typeof InputEwFrequencyRangeInputUnitEnum];


/**
 * Check if a given object implements the InputEwFrequencyRangeInput interface.
 */
export function instanceOfInputEwFrequencyRangeInput(value: object): boolean {
    if (!('max' in value)) return false;
    if (!('min' in value)) return false;
    if (!('unit' in value)) return false;
    return true;
}

export function InputEwFrequencyRangeInputFromJSON(json: any): InputEwFrequencyRangeInput {
    return InputEwFrequencyRangeInputFromJSONTyped(json, false);
}

export function InputEwFrequencyRangeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputEwFrequencyRangeInput {
    if (json == null) {
        return json;
    }
    return {
        
        'max': json['max'],
        'min': json['min'],
        'unit': json['unit'],
    };
}

export function InputEwFrequencyRangeInputToJSON(value?: InputEwFrequencyRangeInput | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'max': value['max'],
        'min': value['min'],
        'unit': value['unit'],
    };
}

